import { render, staticRenderFns } from "./rejectNewUser.vue?vue&type=template&id=27013c7f&"
import script from "./rejectNewUser.vue?vue&type=script&lang=js&"
export * from "./rejectNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports